import React from 'react';
import { difficultyColor, ratingColor } from './reportColors';

// 리포트 v2의 현재 점수 표시. 데이터 조회 없이 숫자·글꼴·색상만 공유한다.
export default function RatingValue({ value, title, size = 22, muted = false }) {
  return (
    <span className={`${size === 16 ? 'text-[16px]' : 'text-[22px]'} font-black leading-none`} style={{ color: muted ? difficultyColor(0) : ratingColor(value) }} title={title}>
      {value != null ? value.toLocaleString('ko-KR') : '—'}
    </span>
  );
}
